/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface SubscriptionItemBase
 */
export interface SubscriptionItemBaseOptional {
  /**
   *
   * @type {number}
   * @memberof SubscriptionItemBase
   */
  cyclePriceOverrideCents?: number;
}

export interface SubscriptionItemBase extends SubscriptionItemBaseOptional {
  /**
   *
   * @type {number}
   * @memberof SubscriptionItemBase
   */
  cyclePriceOverrideCents?: number;
}

export interface SubscriptionItemBaseTrackedI {
  /**
   *
   * @type {number}
   * @memberof SubscriptionItemBase
   */
  cyclePriceOverrideCents?: number;
  cyclePriceOverrideCentsIsSet: boolean;
}

transformDatesMap.set(
  "SubscriptionItemBase",
  function (model: SubscriptionItemBase) {},
);

export type SubscriptionItemBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  cyclePriceOverrideCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var SubscriptionItemBaseMeta: SubscriptionItemBaseMetaI =
  {} as SubscriptionItemBaseMetaI;
SubscriptionItemBaseMeta = typeMeta("SubscriptionItemBase", {
  cyclePriceOverrideCents: propertyMeta(
    "cyclePriceOverrideCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = SubscriptionItemBaseMeta;

registerMeta(() => {});

export class SubscriptionItemBaseTracked implements SubscriptionItemBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  cyclePriceOverrideCents__I?: number = undefined;
  cyclePriceOverrideCentsIsSet: boolean = false;
  set cyclePriceOverrideCents(v: undefined | number) {
    if (v !== undefined) {
      this.cyclePriceOverrideCents__I = v;
      this.cyclePriceOverrideCentsIsSet = true;
    } else {
      this.cyclePriceOverrideCents__I = v || undefined;
      this.cyclePriceOverrideCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get cyclePriceOverrideCents() {
    return this.cyclePriceOverrideCents__I;
  }
  constructor(config?: SubscriptionItemBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: SubscriptionItemBaseOptional,
    options?: AssignOptions,
  ): SubscriptionItemBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.cyclePriceOverrideCents &&
      this.cyclePriceOverrideCentsApplyFilter(optionsRequired.filter)
    ) {
      this.cyclePriceOverrideCents = config.cyclePriceOverrideCents;
      if (optionsRequired.unassign) this.cyclePriceOverrideCentsIsSet = false;
      else this.cyclePriceOverrideCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): SubscriptionItemBaseTrackedI {
    const cloned = {} as SubscriptionItemBaseTrackedI;
    if (
      this.cyclePriceOverrideCentsIsSetDeep() &&
      this.cyclePriceOverrideCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cyclePriceOverrideCentsIsSet = true;
      cloned.cyclePriceOverrideCents = this.cyclePriceOverrideCents;
    } else {
      //cloned.cyclePriceOverrideCentsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): SubscriptionItemBaseTrackedI {
    if (!this.cyclePriceOverrideCentsApplyFilter(filter))
      this.cyclePriceOverrideCentsIsSet = false;

    return this;
  }
  cyclePriceOverrideCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      SubscriptionItemBaseMeta.cyclePriceOverrideCents,
      SubscriptionItemBaseMeta,
      this.cyclePriceOverrideCents,
      this,
    );
  }
  cyclePriceOverrideCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cyclePriceOverrideCentsIsSet &&
      this.cyclePriceOverrideCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.cyclePriceOverrideCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
